module.exports = __webpack_public_path__ + "static/media/previewLarge.22126e9b.svg";